<div class="container">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10 col-12 mt-4 pt-2">
      <div class="company-list card border-0 rounded shadow bg-white">
        <div class="row">
          <div class="col-lg-7 col-md-6">
            <div class="text-center py-4 border-bottom">
              <img [src]="businessObject.logo" class="avatar avatar-medium mx-auto rounded-circle d-block mb-3" alt="">
              <a target="_blank" routerLink="/{{ businessObject.name }}" class="text-dark fs-5 name">{{ businessObject.name }}</a>
            </div>
            <div class="p-4">
              <h5 class="pt-4 d-inline-block">{{ 'Buyer.Amount' | translate }}:</h5>
              <h4 class="ms-2 fw-bold d-inline-block text-primary">{{ this.vpihs.total.toFixed(2) }} {{ getProductValueByFieldName('Currency') }}</h4>
              <div class="d-grid my-3">
                <button *ngIf="payable" (click)="proceedToPayment()" class="btn btn-soft-primary">{{ 'Buyer.PayNow' | translate }}</button>
                <app-share *ngIf="!payable" [showEmail]="true" [url]="sharedLink"></app-share>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 border-left ps-1">
            <div class="d-grid h-100 align-items-center justify-content-center">
              <div class="d-inline-block">
                <qrcode [qrdata]="QRData" [width]="QRWidth" [level]="'L'"></qrcode>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
